<template>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon"
      width="30px"
      height="30px"
      viewBox="0 0 1024 1024"
      version="1.1"
    >
      <path
        d="M728.015238 298.666667h142.872381v589.531428c0 30.47619-23.161905 53.638095-53.638095 53.638095H245.76c-30.47619 0-53.638095-23.161905-53.638095-53.638095v-714.361905c0-30.47619 23.161905-53.638095 53.638095-53.638095H692.419048v142.872381h35.84v35.596191z m-53.638095-17.798096V137.99619H245.76c-19.748571 0-35.84 16.091429-35.84 35.84v714.361905c0 19.748571 16.091429 35.84 35.84 35.84h571.489524c19.748571 0 35.84-16.091429 35.84-35.84V316.464762h-142.872381v-35.84h-35.84z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M701.19619 316.464762h-26.819047V119.954286h17.798095v17.798095h17.798095v17.798095h17.798096v17.798095h17.798095v17.798096h17.798095v17.798095h17.798095V226.742857h17.798096v17.798095h17.798095v17.798096h17.798095v17.798095h17.798095v17.798095h17.798095v17.798095h-196.510476v-26.819047c0.731429 15.11619 13.165714 27.550476 27.550476 27.550476z m0 0"
        fill="#9FA0A6"
      />
      <path
        d="M174.32381 209.432381h285.744761c19.748571 0 35.84 16.091429 35.84 35.84v285.744762c0 19.748571-16.091429 35.84-35.84 35.84H174.32381c-19.748571 0-35.84-16.091429-35.84-35.84V245.028571c0-19.504762 16.091429-35.59619 35.84-35.59619z m0 0"
        fill="#09CC6E"
      />
      <path
        d="M404.967619 502.00381h-51.931429c-3.657143 0-6.826667-1.950476-8.533333-5.12l-38.278095-70.460953c-1.462857-2.681905-2.925714-7.801905-4.632381-14.872381h-0.487619c-0.731429 3.413333-2.438095 8.289524-5.12 14.872381-0.24381 0.24381-0.24381 0.731429-0.487619 0.975238l-38.034286 69.729524c-1.706667 3.169524-4.87619 5.12-8.533333 5.12H214.308571c-7.558095 0-12.190476-8.533333-8.045714-14.872381l60.464762-94.110476c1.950476-3.169524 1.950476-7.070476 0.24381-9.996191l-55.344762-94.110476c-3.657143-6.339048 0.975238-14.628571 8.289523-14.628571H256c3.657143 0 7.070476 2.194286 8.777143 5.363809l31.451428 64.365715c2.681905 5.607619 5.12 11.946667 7.070477 18.773333h0.487619c1.950476-6.095238 4.388571-12.434286 7.314285-19.017143 0.24381-0.24381 0.24381-0.487619 0.487619-0.975238l34.620953-63.634286c1.706667-3.169524 4.87619-5.12 8.533333-5.12h31.207619c7.558095 0 12.190476 8.289524 8.289524 14.628572l-56.807619 93.135238c-1.950476 3.169524-1.950476 7.070476 0 9.99619l67.535238 109.958096z m0 0"
        fill="#FFFFFF"
      />
      <path
        d="M261.12 834.56h535.893333V870.4H261.12v-35.84z m0-89.234286h535.893333v35.84H261.12v-35.84z m0-89.478095h535.893333v35.84H261.12V655.847619z m0 0"
        fill="#9FA0A6"
      />
    </svg>
</template>

<script setup lang="ts"></script>

<style scoped></style>
